import styled from 'styled-components'
import { Tags } from 'components/tags/s'

export const Values = styled(Tags)`
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    min-height: 40px;
`
